import LoLResultItem from './LoLResultItem';

export default LoLResultItem;
